import { useContext, useEffect, useMemo, useState } from 'react'
import { DesignContext } from 'contexts/DesignContext'

import objectPath from 'object-path'
import { Form, Col, Row, InputGroup } from 'react-bootstrap'
import Label from './Label'
import InputPrepend from './InputPrepend'
import InputAppend from './InputAppend'
import { applyMask } from '../action/Data'
import { createUischemaStyle } from './Style'
import {
  cancelDebounceCallback,
  debounceCallback,
} from 'utility/debounceCallback.util'

const CustomInputMask = (props) => {
  let {
    value,
    uischema,
    updateData,
    errors = {},
    label,
    setIsOnChange,
    fieldName,
    fieldKey,
  } = props

  let {
    key,
    elementWidth,
    placeholder,
    mask,
    controlId,
    suffixText,
    require,
  } = uischema

  const designContext = useContext(DesignContext)
  const { elementAction } = designContext

  let errorArray = objectPath.get(errors, key) || []
  const isLocked = objectPath.get(elementAction, ['isLockedEdit'])
  let hasEnable = objectPath.has(elementAction, ['isEnable', key])
  let isEnable = objectPath.get(elementAction, ['isEnable', key])
  let isReadOnly = useMemo(() => {
    if (isLocked) return isLocked
    if (hasEnable) {
      return isEnable === false ? true : false
    }
    return uischema.readonly
  }, [isEnable, uischema.readonly])

  let hasRequire = objectPath.has(elementAction, ['isRequire', key])
  let requireMessage = objectPath.get(elementAction, ['isRequire', key])
  let showRequireMessage = hasRequire
    ? typeof requireMessage !== 'boolean'
    : require
  let isRequire = hasRequire || require
  let showRequire = value ? false : isRequire ? true : false

  let hasWarning = objectPath.has(elementAction, ['isWarning', key])
  let warningMessage = objectPath.get(elementAction, ['isWarning', key])
  let showWarningMessage = hasWarning
    ? typeof warningMessage !== 'boolean'
    : warningMessage
  const getInputMaskValue = (value) => {
    return applyMask(value?.toString() || '', mask) || ''
  }
  const getMaxRawLength = () => {
    return String(mask || '')
      .split('')
      .filter((value) => ['9', 'a', '*'].includes(value)).length
  }
  const getRawInputMaskValue = (value) => {
    let rawValue = value.replace(/\D/g, '')
    let maxRawLength = getMaxRawLength()

    return maxRawLength ? rawValue.slice(0, maxRawLength) : rawValue
  }
  const [inputValue, setInputValue] = useState(getInputMaskValue(value))
  const debounceInputName = `input-mask-update-${fieldKey}`
  const updateInputMaskData = (value) => {
    updateData(value, true)
  }

  const uiStyle = useMemo(
    () => createUischemaStyle({ uischema, showRequire }),
    [uischema, showRequire],
  )

  useEffect(() => {
    let nextValue = getInputMaskValue(value)
    if (nextValue !== inputValue) {
      setInputValue(nextValue)
    }
  }, [value, mask])

  return (
    <Form.Group className="mb-0" controlId={controlId}>
      <Row className="w-100 mx-0">
        <Label
          {...props}
          uischema={uischema}
          label={label}
          isRequire={isRequire}
          isEnable={!isReadOnly}
        />
        <Col sm={elementWidth} className="mt-1 p-0">
          <InputGroup style={{ flexWrap: 'unset' }}>
            <InputPrepend isReadOnly={isReadOnly} uischema={uischema} />
            {isReadOnly ? (
              <Form.Control
                type="text"
                autoComplete="off"
                id={`input-readonly-${fieldKey}`}
                name={`input-readonly-${fieldName}`}
                placeholder={placeholder}
                readOnly={isReadOnly}
                value={value || ''}
              />
            ) : (
              <Form.Control
                id={fieldKey}
                name={fieldName}
                type="text"
                style={{ height: 35, ...uiStyle }}
                autoComplete="off"
                placeholder={placeholder}
                value={inputValue || ''}
                onChange={(e) => {
                  let value = e.target.value
                  let rawValue = getRawInputMaskValue(value)
                  setInputValue(getInputMaskValue(rawValue))
                  debounceCallback(
                    updateInputMaskData,
                    [rawValue],
                    debounceInputName,
                    250,
                  )
                  setIsOnChange(true)
                }}
                onBlur={(e) => {
                  let rawValue = getRawInputMaskValue(e.target.value)
                  setInputValue(getInputMaskValue(rawValue))
                  cancelDebounceCallback(debounceInputName)
                  updateInputMaskData(rawValue)
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    let rawValue = getRawInputMaskValue(e.target.value)
                    setInputValue(getInputMaskValue(rawValue))
                    cancelDebounceCallback(debounceInputName)
                    updateInputMaskData(rawValue)
                  }
                }}
                disabled={isReadOnly}
              />
            )}
            <InputAppend isReadOnly={isReadOnly} uischema={uischema} />
          </InputGroup>
          <ul className="m-0 mt-2 pl-3">
            {showRequire && showRequireMessage && requireMessage && (
              <li className="text-danger">{requireMessage}</li>
            )}
            {showWarningMessage && warningMessage && (
              <li className="text-danger">{warningMessage}</li>
            )}
            {errorArray.map((error, index) => (
              <li key={`error-${key}-${index + 1}`} className="text-danger">
                {error}
              </li>
            ))}
          </ul>
        </Col>
        {suffixText && (
          <Col className="d-flex align-items-center mt-1 pr-0" sm="auto">
            <Form.Label className={`m-0 w-100`}>{suffixText}</Form.Label>
          </Col>
        )}
      </Row>
    </Form.Group>
  )
}

export default CustomInputMask
